export enum InfoSection {
  WORKSPACE = "workspace",
  TEMPLATE = "template",
}
